<template>
    <Label :label="label" :has-error="hasErrors" :error-message="getErrorMessage">
        <input type="number" :id="name"
               :name="name"
               v-model="inputValue"
               :placeholder="placeholder"
               :min="min"
               :max="max"
               :step="step"
               :class="[{'border-red-300': hasErrors}]"
               class='py-5 px-4 text-lg font-medium font-sans border border-grey-300 p-3 rounded-lg'>
    </Label>
</template>
<script setup>
import {computed, ref, watch} from "vue";
import Label from "./Label.vue";

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    name: '',
    label: '',
    placeholder: '',
    min: null,
    max: null,
    step: null,
    modelValue: null,
    errors: {
        type: Object,
        default: () => ({})  // Ensure errors defaults to an empty object
    }
});

const hasErrors = computed(() => {
    return props.errors[props.name]?.length > 0;
});

const getErrorMessage = computed(() => {
    return props.errors[props.name]?.length ? props.errors[props.name][0] : ''
});

const inputValue = ref(props.modelValue);

watch(inputValue, (newValue) => {
    emit('update:modelValue', newValue);
});

watch(() => props.modelValue, (newValue) => {
    inputValue.value = newValue;
});
</script>
